export default __webpack_public_path__ + "static/media/usEPA.65eb681a.png";